import React from 'react';
import Lottie from 'react-lottie';
import i18next from 'i18next';
import { useSelector } from 'react-redux';

import { getLottieOptions } from '~utils/lottie';
import uniqueLoading from '~assets/lotties/unique-loading.json';
import CreditEndingStatus from '~app/components/CreditEndingStatus';
import SimulationNewFlowWrapper from '~app/components/SimulationNewFlowWrapper';
import { useFlowChoice } from '~app/hooks/useFlowChoice';
import { useRedirect } from '~hooks/useRedirect';
import { FLOW_CHOICE_OPTIONS } from '~constants/flowChoice';
import { INCUMBENT_TYPES } from '~constants/incumbent';
import { ROUTES } from '~constants/routes';
import { getStepNameByFlowChoice } from '~screens/ClientFlowChoice/utils';

import styles from './styles.module.scss';

export default function EvaluationPending() {
  const { changeIncumbentLoading, clientFlowChoice, clientFinancialInfo } = useSelector(
    state => state.simulation
  );
  const { handleManualChoice } = useFlowChoice({
    incumbent: INCUMBENT_TYPES.CLIENT,
    currentFlowChoice: clientFlowChoice,
    getStepNameByFlowChoice: getStepNameByFlowChoice(clientFinancialInfo)
  });
  const handleRedirect = useRedirect();
  // After the native ClaveÚnica login the incomes come from miChileAtiende, so the
  // client continues with the documents (as after the legacy ClaveÚnica scraper)
  // instead of being switched to the manual flow.
  const handleContinue =
    clientFlowChoice === FLOW_CHOICE_OPTIONS.AUTOMATIC
      ? handleRedirect({ customStepName: ROUTES.CLIENT_PERSONAL_DOCUMENTATION.stepName })
      : handleManualChoice;
  const evaluationAnim = () => (
    <div className={styles.salesContainer}>
      <Lottie
        options={getLottieOptions({
          loop: true,
          autoplay: true,
          animationData: uniqueLoading
        })}
      />
    </div>
  );
  return (
    <SimulationNewFlowWrapper previousStepName={ROUTES.CLIENT_FLOW_CHOICE.stepName}>
      <CreditEndingStatus
        title={i18next.t('EvaluationPending:title')}
        info={i18next.t('EvaluationPending:info')}
        summaryButton={i18next.t('EvaluationPending:summaryButton')}
        Image={evaluationAnim}
        loading={changeIncumbentLoading}
        handleCheckout={handleContinue}
      />
    </SimulationNewFlowWrapper>
  );
}
